<header class="sticky top-0 z-30 flex h-14 items-center gap-4 border-b border-slate-200 bg-white px-4 shadow-sm">
  <div class="flex shrink-0 items-center gap-2">
    @if (logoUrl(); as src) {
      <img [src]="src" [alt]="brandName() || 'Freightify'" class="h-8 max-w-[140px] object-contain" />
    } @else {
      <span class="grid h-8 w-8 place-items-center rounded-md font-bold text-white" style="background-color: var(--p-primary-color)"
        >F</span
      >
      <span class="text-lg font-semibold tracking-tight text-slate-800">{{ brandName() || 'Freightify' }}</span>
    }
  </div>

  <nav class="flex min-w-0 flex-1 items-center overflow-x-auto" aria-label="Main navigation">
    <p-menubar [model]="menuItems()" styleClass="lib-header-menubar border-0 bg-transparent p-0" />
  </nav>

  <div class="ml-auto flex shrink-0 items-center gap-2">
    @if (hasCreateMenu()) {
      <p-tiered-menu #createMenu [model]="createMenuItems()" [popup]="true" appendTo="body" />
      <p-button
        label="New"
        icon="pi pi-plus"
        iconPos="left"
        [outlined]="true"
        ariaLabel="Create new"
        (onClick)="createMenu.toggle($event)"
      />
    }

    <p-button
      label="Upload Rate File"
      icon="pi pi-upload"
      iconPos="left"
      [outlined]="true"
      ariaLabel="Upload rate file"
      (onClick)="onUploadRateFileClick()"
    />

    <p-button icon="pi pi-bell" [rounded]="true" [text]="true" severity="secondary" ariaLabel="Notifications" />
    <p-button icon="pi pi-cog" [rounded]="true" [text]="true" severity="secondary" ariaLabel="Settings" />
    <p-avatar label="S" shape="circle" styleClass="bg-blue-100 text-blue-700 font-semibold" />
    <p-button icon="pi pi-sign-out" [rounded]="true" [text]="true" severity="secondary" ariaLabel="Sign out" (onClick)="onLogoutClick()" />
  </div>
</header>
